import {
  PROMISE_PENDING,
	PROMISE_REJECTED,
	PROMISE_FULFILLED,
  SORT_FILTER_SELLING_SELLER,
  SORT_FILTER_PROCESS_SELLER,
  SORT_FILTER_HISTORY_SELLER
} from '../constants';

const initialState = {
  doSellingSortFilter: {
    isFetch: false,
    dataSelling: [],
    status_code: 0,
    error: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  doProcessSortFilter: {
    isFetch: false,
    dataProcess: [],
    status_code: 0,
    error: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  doHistorySortFilter: {
    isFetch: false,
    dataHistory: [],
    status_code: 0,
    error: null,
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  }
}

const sellingDashboard = (state, {data: { data, last_page, current_page, per_page, total }, status_code}) => {
  let newState = {
    ...state,
    doSellingSortFilter: {
      ...state.doSellingSortFilter,
      isFetch: false,
      dataSelling: [...data],
      status_code: null,
      last_page,
      current_page,
      per_page,
      total
    }
  }
  return newState
}

const processDashboard = (state, {data: { data, last_page, current_page, per_page, total }, status_code}) => {
  let newState = {
    ...state,
    doProcessSortFilter: {
      ...state.doProcessSortFilter,
      isFetch: false,
      dataProcess: [...data],
      status_code: null,
      last_page,
      current_page,
      per_page,
      total
    }
  }
  return newState
}

const historyDashboard = (state, {data: { data, last_page, current_page, per_page, total }, status_code}) => {
  let newState = {
    ...state,
    doHistorySortFilter: {
      ...state.doHistorySortFilter,
      isFetch: false,
      dataHistory: [...data],
      status_code: null,
      last_page,
      current_page,
      per_page,
      total
    }
  }
  return newState
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //sort  and filter selling
    case `${SORT_FILTER_SELLING_SELLER}${PROMISE_PENDING}` :
      return {...state, doSellingSortFilter: {...state.doSellingSortFilter, isFetch: true}}
    
    case `${SORT_FILTER_SELLING_SELLER}${PROMISE_FULFILLED}` : 
      // const {data, status_code } = action.payload
      // return {...state, doSellingSortFilter: {...state.doSellingSortFilter, data, status_code, isFetch: false, error: null}}
      return (sellingDashboard(state, action.payload));
    

    //sort and filter process
    case `${SORT_FILTER_PROCESS_SELLER}${PROMISE_PENDING}` :
      return {...state, doProcessSortFilter: {...state.doProcessSortFilter, isFetch: true}}

    case `${SORT_FILTER_PROCESS_SELLER}${PROMISE_FULFILLED}` : 
      // const {data, status_code } = action.payload
      // return {...state, doProcessSortFilter: {...state.doProcessSortFilter, data, status_code, isFetch: false, error: null}}
      return (processDashboard(state, action.payload));

    //sort and filter history
    case `${SORT_FILTER_HISTORY_SELLER}${PROMISE_PENDING}` :
      return {...state, doHistorySortFilter: {...state.doHistorySortFilter, isFetch: true}}

    case `${SORT_FILTER_HISTORY_SELLER}${PROMISE_FULFILLED}` : 
      // const {data, status_code } = action.payload
      // return {...state, doHistorySortFilter: {...state.doHistorySortFilter, data, status_code, isFetch: false, error: null}}
      return (historyDashboard(state, action.payload));
    
    
    default: return state;
  }
}

export default reducer;